import React, {Component} from 'react';
import SearchingTitleComponent from './SearchingTitleComponent';
import ReactDOM from 'react-dom';
import { Badge, Col, Row } from 'reactstrap';
import { GetListAttempt_ACTION, GetMultipleListAttempt_ACTION } from '../Actions/LogisticActions';
import {connect} from 'react-redux'
import { Routes } from '../Services/API';
import ModalComponent from './ModalComponent';
import ImageTreeNode from './ImageTreeNode';
import {Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle} from 'react-shapes';
import Slider from '@material-ui/core/Slider';
import NameComponent from './NameComponent';

class ClickableQuestionAnswerViewComponent extends Component {
    constructor(props){
        super(props)

        this.state = {
           
            Offset:0
        }


    }

    render(){
        let RefWidth = this.state.RefWidth
        return(
            <div
            ref = {'Container_Div'}

            >
                <Row style = {{width:'100%'}}>
                    <Col xs = {12}>
               <img 
                    style = {{
                        backgroundPosition:'center',
                        backgroundRepeat:'no-repeat',
                        backgroundSize:'contain',
                        height:this.props.Height,
                        width: this.props.Width,
                        border:1,
                        borderColor:'#cccccc',
                        borderStyle:'dashed'
                    }} 
                   
                    src = {this.props.Question.BackgroundImageURL}
                    ref = {'Image_Div'}
                                         
                    onLoad = {(Image) => {
                        Image.persist()
  
                        var ImageDiv = ReactDOM.findDOMNode(this.refs['Image_Div'])
                        .getBoundingClientRect()

                      var Container_Div =  ReactDOM.findDOMNode(this.refs['Container_Div'])

                        this.setState({
                            ImageX: ImageDiv.x,
                            ImageY:  ImageDiv.y,
                            RefWidth: Container_Div.children[0].childNodes[0].clientWidth
                            })
                    }}
                                               
                                               
                            />
                    {this.props.Question.ClickImages.map((p, index) => (
                        <span  key = {index}
                            style = {{
                                position: 'absolute',
                                width: ((RefWidth)/this.props.Question.BackgroundImageWidth)* p.Width,
                                height: ((RefWidth)/this.props.Question.BackgroundImageWidth)*p.Height,
                                left: ((RefWidth)/this.props.Question.BackgroundImageWidth)*p.X,
                                top:  ((RefWidth)/this.props.Question.BackgroundImageWidth)*p.Y,
                            }}
                            >
                                <Row style = {{alignItems:'center', justifyContent:'center', display:'flex'}} >
                                    <img 
                                        src = {p.Image}
                                        style = {{
                                            width: ((RefWidth)/this.props.Question.BackgroundImageWidth)* p.Width,
                                            height: ((RefWidth)/this.props.Question.BackgroundImageWidth)*p.Height,
                                        }}
                                    />
                                </Row>
                                                
                                                    
                            </span>
                                    ))}
                                    {this.props.Question.ClickCharts.map((p, index) => (
                        <span  key = {index}
                            style = {{
                                position: 'absolute',
                                width: ((RefWidth)/this.props.Question.BackgroundImageWidth)* p.Width,
                                height: ((RefWidth)/this.props.Question.BackgroundImageWidth)*p.Height,
                                left: ((RefWidth)/this.props.Question.BackgroundImageWidth)*p.X,
                                top:  ((RefWidth)/this.props.Question.BackgroundImageWidth)*p.Y,
                            }}
                            >
                                <Row style = {{alignItems:'center', justifyContent:'center', display:'flex'}} >
                                    <img 
                                        src = {p.Image}
                                        style = {{
                                            width: ((RefWidth)/this.props.Question.BackgroundImageWidth)* p.Width,
                                            height: ((RefWidth)/this.props.Question.BackgroundImageWidth)*p.Height,
                                        }}
                                    />
                                </Row>
                                                
                                                    
                            </span>
                                    ))}
                            
                      
                            </Col>
                            </Row>
                  </div>
        )
    }

    
}

function MapStateToProps(state) {
    return {

    }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        
  }
}
  
export default connect(MapStateToProps, MapDispatchToProps)(ClickableQuestionAnswerViewComponent)